import React from "react";
import { Text, Box, Flex, Link, withTheme } from "mineral-ui";
import MaxWidth from "./MaxWidth";

const Footer = ({ theme }) => (
  <Box
    paddingVertical="lg"
    style={{ backgroundColor: theme.backgroundColor_disabled }}
  >
    <MaxWidth>
      <Flex direction="column" alignItems="center" paddingHorizontal="sm">
        <Text appearance="mouse" align="center">
          Copyright &copy; 2021, Graphile Ltd.
        </Text>
        <Text appearance="mouse" align="center">
          <Link href="/terms">Terms and Conditions</Link> |{" "}
          <Link href="/privacy">Privacy and Cookies Policy</Link>
        </Text>
        <Text appearance="mouse" align="center">
          Graphile Ltd is a limited company registered in England and Wales,
          company number: 11171700, registered address: Tremain House, 8 Maple
          Drive, Kings Worthy, Winchester, Hampshire, SO23 7NG, United Kingdom
        </Text>
      </Flex>
    </MaxWidth>
  </Box>
);

export default withTheme(Footer);
